export default "__VITE_ASSET__DJxBdKQb__"